import * as S from '@/components/common/Banner/SubBanner/style';
interface SubBannerProps {
	title: string;
	subTitle: string;
	img: string;
}
const SubBanner = ({ title, subTitle, img }: SubBannerProps) => (
	<S.SubBannerContainer bgImg={img}>
		<S.TextBoxWrapper>
			<div className="sub_title">{subTitle}</div>
			<div className="title">{title}</div>
		</S.TextBoxWrapper>
	</S.SubBannerContainer>
);

export default SubBanner;
